import { ExclusionConfirmationMethodModal } from 'components/ExclusionConfirmationMethodModal'
import { useMetadataUser } from 'contexts/metadata-user-context'
import { useState } from 'react'
import { FaRegTrashCan } from 'react-icons/fa6'
import { deleteEmployee } from 'services/delete-employee'
import { Employee } from 'types/employee'

type TableProps = {
  data: Employee[]
}

export function Table({ data }: Readonly<TableProps>) {
  const { profile } = useMetadataUser()
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [employeeId, setEmployeeId] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const traduzirStatus = (status: string) => {
    switch (status) {
      case 'SUBSCRIBER':
        return 'Com plano'
      case 'NON-SUBSCRIBER':
        return 'Sem plano'
      case 'INACTIVE':
        return 'Inativo'
      default:
        return status
    }
  }

  const renderStatus = (status: string) => {
    const statusTraduzido = traduzirStatus(status)

    let cor = ''

    switch (statusTraduzido) {
      case 'Com plano':
        cor =
          'bg-green-500/30 text-green-800 dark:bg-green-500 dark:text-green-100'
        break
      case 'Sem plano':
        cor =
          'bg-yellow-500/30 text-yellow-800 dark:bg-yellow-500 dark:text-yellow-100'
        break
      case 'Inativo':
        cor = 'bg-red-500/30 text-red-800 dark:bg-red-500 dark:text-red-100'
        break
      default:
        break
    }

    return (
      <span className={`rounded-full py-1 px-3 text-xs font-medium ${cor}`}>
        {statusTraduzido}
      </span>
    )
  }

  const handleDeleteEmployee = () => {
    setIsLoading(true)

    deleteEmployee(employeeId).then(() => {
      setIsOpenModal(false)
      window.location.reload()
      setIsLoading(false)
    })
  }

  return (
    <>
      <table className="w-full">
        <thead className="bg-neutral-100 dark:bg-neutral-800">
          <tr>
            <th className="text-left py-2 px-4 font-medium text-neutral-600 dark:text-neutral-200">
              E-mail
            </th>
            <th className="text-left py-2 px-4 font-medium text-neutral-600 dark:text-neutral-200">
              Status
            </th>
            <th className="text-left py-2 px-4"></th>
          </tr>
        </thead>
        <tbody>
          {data?.map((employee) => (
            <tr key={employee.id}>
              <td className="py-4 px-4 border-b dark:border-b-neutral-800">
                {employee.email}
              </td>
              <td className="py-4 px-4 border-b dark:border-b-neutral-800">
                {renderStatus(employee.status)}
              </td>
              <td className="py-4 px-4 border-b dark:border-b-neutral-800">
                {profile?.id === employee?.user_id ? null : (
                  <button
                    onClick={() => {
                      setIsOpenModal(true)
                      setEmployeeId(employee.id)
                    }}
                  >
                    <FaRegTrashCan className="w-5 h-5 cursor-pointer" />
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {isOpenModal && (
        <ExclusionConfirmationMethodModal
          title="Tem certeza que deseja excluir esse funcionário?"
          handleEvent={handleDeleteEmployee}
          setIsOpenModal={setIsOpenModal}
          isLoading={isLoading}
        />
      )}
    </>
  )
}
